import { getStatusDescriptionFromStatusValue } from '../../../../../utils/utility';

export default function myDashboardDCDealsTableColumns(config) {
    const { dealList = [] } = config.data;
    let result = {};
    let tableData = [];
    let dealData = {};

    dealList.forEach(deal => {
        let row = [];
        const rowId = deal.dealId;
        config.columns.forEach(column => {
            let columnValue = "";
            let linkDestination = "";

            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs === "string") {
                if (column.id === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(deal.status) || "";
                    displayAsIs = true;
                }
                else if (column.id === "startYear") {
                    columnValue = deal.startYear || "";
                    displayAsIs = true;
                }
                else if (column.id === "endYear") {
                    columnValue = deal.endYear || "";
                    displayAsIs = true;
                }
            }
            else if (column.data.displayInBodyAs === "link") {
                if (column.id === "dealCode" && deal.dealId) {
                    displayAsIs = true;
                    columnValue = deal.dealId;
                    linkDestination = '/my-customer-orders';
                    dealData = { dealId: deal.dealId };
                }
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    linkDestination: linkDestination,
                    dealData: dealData,
                    showInMobileViewAs: column.showInMobileViewAs
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}